import { Component, OnInit, Input } from '@angular/core';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UiFactory } from '../../core/ui/ui-factory';
import { SwitchModel } from './switch-model';
import { BehaviorService } from '../../core/behavior/behavior.service';

@Component({
  selector: 'pg-switch-factory, grit-switch-factory',
  templateUrl: './pg-switch-factory.component.html',
  styleUrls: ['./pg-switch-factory.component.scss'],
})
export class PgSwitchFactoryComponent extends UiFactory {
  @Input() parentFormGroup: FormGroup;

  @Input() model: any;

  get switchModel(): SwitchModel {
    return this.model;
  }

  constructor(behaviorService: BehaviorService) {
    super(behaviorService);
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.parentFormGroup) {
      throw new Error(
        'parentFormGroup is a required input for pg-switch-factory'
      );
    }
    let control = this.parentFormGroup.get(this.model.formControlName);
    if (!control) {
      this.parentFormGroup.addControl(
        this.model.formControlName,
        new FormControl()
      );
    }
  }
}
